import store from "@/app/store/store";
import { AssureEditionEnum } from "@/app/api/battery-portal-api";
export function isLicenseAllowed(rule) {
    if (!rule)
        return true;
    const hostingOption = store.getters["licenseModule/hostingOption"];
    const appEdition = store.getters["licenseModule/appEdition"];
    // Only check hosting option if rule specifies one
    if (rule.hostingOption !== undefined && hostingOption !== rule.hostingOption) {
        return false;
    }
    // Check minimum edition requirement
    if (rule.minimumEdition !== undefined) {
        const editionHierarchy = [
            AssureEditionEnum.OnPremBasic,
            AssureEditionEnum.OnPremStandard,
            AssureEditionEnum.OnPremPremium
        ];
        const currentIndex = editionHierarchy.indexOf(appEdition);
        const requiredIndex = editionHierarchy.indexOf(rule.minimumEdition);
        // Cloud Standard has access to all features
        if (appEdition !== AssureEditionEnum.PowershieldCloudStandard) {
            if (currentIndex < requiredIndex) {
                return false;
            }
        }
    }
    return true;
}
export function getPermissionsForEdition(permissions) {
    if (!permissions || permissions.length === 0)
        return [];
    return permissions.filter(p => {
        // If both constraints are null/undefined, the rule is satisfied.
        if (p.hostingOption === undefined && p.minimumEdition === undefined)
            return true;
        // Reuse the same hosting/edition matching used by route license rules
        // so behaviour stays consistent across the app.
        return isLicenseAllowed({
            hostingOption: p.hostingOption,
            minimumEdition: p.minimumEdition,
        });
    });
}
